import {
    apiRequest,
    perhitunganList,
    perhitunganSubmit
} from "../../../../../services/adapters/master/penialian360Service"

class PerhitunganRepository {

   fetchList = async (query) => {
        return await apiRequest("get", perhitunganList, {
            params: query
        }, true)
    }

    fetchSubmit = async (query) => {
        return await apiRequest("post", perhitunganSubmit, {
            body: query
        }, true)
    }

}

export default PerhitunganRepository